import api from './api';


const uploadFile = async (payload) => {
    let response = await api.post('/file/stored-list', payload, {
        headers: {
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }
    });
    return response
}

const getStoredList = async () => {
    let response = await api.get('/file/stored-list');
    return response
}

const updateStoredListStatus = async (id, payload) => {
    let response = await api.post(`/file/stored-list/${id}`, JSON.stringify({
        status: payload
    }));
    return response
}

export {
    uploadFile,
    getStoredList,
    updateStoredListStatus
}